module.exports = __webpack_public_path__ + "static/media/search-mobile.32901a85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/Menu/assets/search-mobile.svg
// module id = ./src/common/Menu/assets/search-mobile.svg
// module chunks = 14